import React from "react";
import CarouselSection from "./sections/carousel";
import EasyNavigationSection from "./sections/easyNavigation";
import MoreAccessedServicesSection from "./sections/moreAccessedServices";
import NewsSection from "./sections/news";
import { HomeProvider } from "./context/home-context";

export function HomePage() {
  return (
    <HomeProvider>
    <>
      <CarouselSection />
      <EasyNavigationSection />
      <MoreAccessedServicesSection />
      <NewsSection />
    </>
    </HomeProvider>
  );
}
